<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card> </v-card>
      </v-col>
      <v-col cols="9">
        <v-card>
          <formqueue></formqueue>
          <RecordNode
            v-if="RecordItem.name !== 'Select a record item to view'"
            :RecordItem="RecordItem"
            :isRoot="true"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import formqueue from "./record-viewer/FormQueue";
import RecordNode from "../record-viewer/RecordNode";
export default {
  name: "Records",
  components: {
    RecordNode,
    formqueue
  },
  data() {
    return {
      RecordItem: {}
    };
  },
  computed: {},
  async created() {
    let fullRecord = await fetch(
      "http://localhost:8000/api/test_records/5e9cbc83dbba979c5a97850c/get_whole_rec"
    )
      .then(res => res.json())
      .then(data => data);
    this.RecordItem = fullRecord;
  },
  mounted() {},
  methods: {}
};
</script>
<style></style>
